import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail } from "lucide-react";
import { BRAND } from "../lib/brand";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ink text-white/85 mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="font-serif-display text-3xl font-bold text-white">
            Six<span className="text-mint italic">Figure</span> Couponer
          </div>
          <p className="mt-4 text-sm text-white/65 leading-relaxed max-w-sm">
            For women who already have the income — and now want the receipts that
            quietly fund the next first-class ticket.
          </p>
        </div>

        <div>
          <h4 className="font-serif-display text-lg text-white mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-mint transition-colors">Home</Link></li>
            <li><Link to="/services" className="hover:text-mint transition-colors">Services</Link></li>
            <li><Link to="/book" className="hover:text-mint transition-colors">Book a Session</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif-display text-lg text-white mb-4">Stay close</h4>
          <p className="text-sm text-white/65 mb-4">
            Monthly notes on the deals worth your time — never your inbox clutter.
          </p>
          <div className="flex gap-3">
            <a href="mailto:hello@sixfigurecouponer.com" data-testid="footer-email" className="p-2.5 rounded-full bg-white/10 hover:bg-mint hover:text-ink transition-colors">
              <Mail size={18} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="p-2.5 rounded-full bg-white/10 hover:bg-mint hover:text-ink transition-colors">
              <Instagram size={18} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" data-testid="footer-youtube" className="p-2.5 rounded-full bg-white/10 hover:bg-mint hover:text-ink transition-colors">
              <Youtube size={18} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/55">
          <span>© {new Date().getFullYear()} {BRAND.name}. Made with quiet luxury.</span>
          <span className="italic">Professional. Warm. Yours.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
